<template>
  <section>
    <div v-if="isSmartPhone" class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <Result @next="next"/>
        </div>
        <div class="swiper-slide">
          <Ranking @prev="prev"/>
        </div>
      </div>
    </div>
    <div v-else class="container">
      <div class="slide">
        <Result @next="next"/>
      </div>
      <div class="line"></div>
      <div class="slide">
        <Ranking @prev="prev"/>
      </div>
    </div>
  </section>
</template>

<script>
import isMobile from "ismobilejs";
import Swiper from "swiper";
import Result from "@/views/Result.vue";
import Ranking from "@/views/Ranking.vue";

export default {
  name: "After",
  components: {
    Result,
    Ranking
  },
  data() {
    return {
      swiper: null,
      isSmartPhone: isMobile.phone
    };
  },
  mounted() {
    if (this.isSmartPhone) {
      this.swiper = new Swiper(".swiper-container", {
        loop: false,
        autoHeight: true,
      });
    }
  },
  methods: {
    prev (e) {
      this.swiper.slidePrev()
    },
    next (e) {
      this.swiper.slideNext()
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  display: flex;
}
.slide {
  width: 50%;
}
.line {
  width: 2px;
  background-color: $text-color;
  margin-top: vw(240, 1600);
}
</style>
